import { render, staticRenderFns } from "./Kschedule.vue?vue&type=template&id=2620e5a3"
import script from "./Kschedule.vue?vue&type=script&lang=js"
export * from "./Kschedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports